import { savedFiltersKey } from "./types";

export const removeFilterView = (pageKey: string, viewId: string) => {
    const savedFilters = localStorage.getItem(savedFiltersKey) || '{}';
    const parsedFilters = JSON.parse(savedFilters);
    const pageInfo = parsedFilters[pageKey] || {};
    const filterViews = pageInfo.filterViews || {};
    delete filterViews[viewId];
    parsedFilters[pageKey] = {
        ...pageInfo,
        filterViews,
    };
    localStorage.setItem(savedFiltersKey, JSON.stringify(parsedFilters));
}